import { formateISODateToStr} from "@/utils/index";

const DateField = ({ value }) => {
  return <div>{formateISODateToStr(value)}</div>;
};
export default DateField;
